"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { Geist, Geist_Mono } from "next/font/google";
import { AppErrorFallback } from "@/components/app-error-fallback";
import "./globals.css";

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});

export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html
      lang="en"
      className={`${geistSans.variable} ${geistMono.variable} h-full min-h-[100dvh] w-full min-w-0 max-w-[100%] antialiased`}
    >
      <body className="flex min-h-[100dvh] w-full min-w-0 max-w-[100%] flex-col overflow-x-hidden">
        <AppErrorFallback retry={unstable_retry} />
      </body>
    </html>
  );
}
